import { defaults } from '@gameday/core/datasources/defaults';
import gumbo from '@gameday/core/datasources/gumbo';
import productConfig from '@gameday/core/datasources/productConfig';

const gamedayDatasources = {
    defaults,
    gumbo,
    productConfig
};
export default gamedayDatasources;
